var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 14,
    viewBox: "0 0 25 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#7d7d7d",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.498 14c-.474 0-.928-.184-1.263-.514L.512 2.98C-.175 2.296-.17 1.196.524.516c.693-.68 1.816-.684 2.514-.011l9.46 9.268 9.46-9.268c.699-.676 1.825-.673 2.518.008.696.68.699 1.783.009 2.467L13.762 13.486c-.335.33-.79.514-1.264.514z",
    transform: "translate(-1304 -441) rotate(180 664.5 227.5)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.418b2c842cd65bc7af0e3ffe57738ab3.svg";
export { ForwardRef as ReactComponent };